import cn from 'clsx';
import { reorderForLeftToRightDisplay } from '@pkgs/components/utils/gridOrder';
import { type WithTestId } from '@pkgs/components/types/types';
import { Breakpoints } from '@pkgs/components/providers/BreakpointProvider';
import { useBreakpoint } from '@pkgs/components/hooks/useBreakpoint';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { getEntries, MarketCountryCode } from '@ev-tech/search-modules-api';

import { ObjectTypeFilterTabSelector } from './ObjectTypeFilterTabSelector';
import { ExpandableCheckbox } from './ObjectTypeFilterExpandableCheckbox';
import { Headline } from '../Headline/Headline';

import styles from './ObjectTypeFilter.module.css';

export const ObjectTypeFilter = ({ className, hasTitle = false, ...props }: WithTestId<{ className?: string; hasTitle?: boolean }>) => {
  const { countryCode, t } = useAppContext();
  const propertyTypeState = useSearchStore((state) => state.propertyTypeState);
  const selectedObjectTypeCategory = useSearchStore((state) => state.objectTypeCategory);
  const { breakpoint = 0 } = useBreakpoint();

  const objectTypeFilterEntries = getEntries(propertyTypeState[selectedObjectTypeCategory]);
  const hasSubTypes = objectTypeFilterEntries.some(([, data]) => Boolean(data?.subTypes));
  const columnCount = breakpoint >= Breakpoints.TABLET_PORTRAIT && objectTypeFilterEntries.length > 3 ? 2 : 1;

  return (
    <div className={cn(styles.root, className)} data-testid="search-components_object-type-filter" {...props}>
      {hasTitle && <Headline label={t('search.searchbar.objectType')} size="h6" />}
      {countryCode !== MarketCountryCode['private-office'] && <ObjectTypeFilterTabSelector />}
      <div className={styles.propertyTypeCheckboxGroup} data-is-grid={!hasSubTypes}>
        {reorderForLeftToRightDisplay(objectTypeFilterEntries, columnCount).map(([propertyType]) => (
          <ExpandableCheckbox key={propertyType} propertyType={propertyType} />
        ))}
      </div>
    </div>
  );
};
